import React from 'react';
import { IframeWrapper } from 'modules/backstage-content/IframeWrapper';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { LANDING_PAGE_STATUS } from '../../consts/landingPageStatus';
import { getLandingPageUrl } from '../../utils/getLandingPageUrl';

const fallBackPage = getLandingPageUrl({
    accountId: 'dev',
    slug: 'taboola-landing-page-preview',
    status: LANDING_PAGE_STATUS.PUBLISHED,
    isPreview: true,
});

export const PreviewSection = ({ className, iframeClassName }) => {
    const { id: numericAccountId } = useAccount();
    const { value: updatedAt } = useFormFieldValue({ field: 'updatedAt' });
    const { value: slug } = useFormFieldValue({ field: 'slug' });
    const { value: status } = useFormFieldValue({ field: 'status' });
    const page =
        numericAccountId && slug
            ? getLandingPageUrl({ accountId: numericAccountId, slug, status, isPreview: true })
            : fallBackPage;

    return (
        <div className={className}>
            <IframeWrapper
                className={iframeClassName}
                title="landing page preview"
                src={`${page}&timestamp=${Date.parse(updatedAt)}`}
            />
        </div>
    );
};
